<template>
  <v-data-table
    :items="items"
    :headers="headers"
    hide-default-footer
    disable-pagination
    item-key="_id"
  >
    <!-- eslint-disable-next-line -->
    <template #item.status="{ item }">
      <plan-status-template :status="item.status" />
    </template>
    <!-- eslint-disable-next-line -->
    <template #item.planid="{ item }">
      <plan-id-template :planid="item.planid" :trial="item.trial" />
    </template>
    <!-- eslint-disable-next-line -->
    <template #item.actualstart="{ item }">
      <span v-if="item.actualstart">
        <plan-start-template :datetime="item.actualstart" />
      </span>
      <span v-else>
        <plan-start-template :datetime="item.scheduledstart" />
      </span>
    </template>
    <!-- eslint-disable-next-line -->
    <template #item.action="{ item }">
      <plan-actions-template :plan="item" />
    </template>
  </v-data-table>
</template>

<script>
import PlanStatusTemplate from './PlanStatusTemplate.vue';
import PlanIdTemplate from './PlanIdTemplate.vue';
import PlanStartTemplate from './PlanStartTemplate.vue';
import PlanActionsTemplate from './PlanActionsTemplate.vue';
import planningConfigMixin from '../../mixins/planning-config';

export default {
  name: 'PartView',
  mixins: [planningConfigMixin],
  components: {
    PlanStatusTemplate,
    PlanIdTemplate,
    PlanStartTemplate,
    PlanActionsTemplate,
  },
  props: {
    items: {
      type: Array,
      required: true,
    },
  },
  computed: {
    headers() {
      const colorColumn = this.isShowColor ? [{
        text: this.$t('assemblyPlanning.color'),
        value: 'color',
        width: '10%',
      }] : [];
      if (this.isLinePartMoldCustomerMode) {
        return [
          { text: '', value: 'status' },
          { text: this.$t('assemblyPlanning.plan'), value: 'planid' },
          {
            text: this.$t('assemblyPlanning.customer'),
            value: 'customer',
            width: '12%',
          },
          ...colorColumn,
          {
            text: this.$t('assemblyPlanning.equipment'),
            value: 'equipmentname',
            width: '12%',
          },
          {
            text: this.$t('assemblyPlanning.remark'),
            value: 'remark',
            width: '12%',
          },
          {
            text: this.$t('assemblyPlanning.line'),
            value: 'linename',
            width: '15%',
          },
          { text: this.$t('assemblyPlanning.plannedQty'), value: 'plannedquantity' },
          { text: this.$t('assemblyPlanning.planStart'), value: 'actualstart' },
          {
            text: this.$t('assemblyPlanning.action'),
            value: 'action',
            sortable: false,
            width: '20%',
          },
        ];
      }
      return [
        { text: '', value: 'status' },
        { text: this.$t('assemblyPlanning.plan'), value: 'planid' },
        {
          text: this.$t('assemblyPlanning.model'),
          value: 'model',
          width: '10%',
        },
        {
          text: this.$t('assemblyPlanning.variant'),
          value: 'variant',
          width: '10%',
        },
        {
          text: this.$t('assemblyPlanning.customer'),
          value: 'customer',
          width: '10%',
        },
        ...colorColumn,
        {
          text: this.$t('assemblyPlanning.remark'),
          value: 'remark',
          width: '10%',
        },
        {
          text: this.$t('assemblyPlanning.line'),
          value: 'linename',
          width: '15%',
        },
        { text: this.$t('assemblyPlanning.plannedQty'), value: 'plannedquantity' },
        { text: this.$t('assemblyPlanning.planStart'), value: 'actualstart' },
        {
          text: this.$t('assemblyPlanning.action'),
          value: 'action',
          sortable: false,
          width: '20%',
        },
      ];
    },
  },
};
</script>
